import Modal from 'react-bootstrap/Modal';

import { ModalButton } from '../../styles/StyledComponents';
import { formatCurrency } from '../../utils/numbers';

const AddDetailReceiptConfirmationModal = ({ show, closeHandler, actionHandler, averageStockValue, currentValue }) => {
    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Advertencia de sobreprecio
            </Modal.Header>
            <Modal.Body>
                <>
                    <p>El valor por unidad para este artículo sobrepasa en más del 20% del último valor promedio en inventario.</p>
                    <ul>
                        <li>Último valor promedio: {`₡${formatCurrency(averageStockValue)}`}</li>
                        <li>Valor ingresado: {`₡${formatCurrency(currentValue)}`}</li>
                    </ul>
                    <p>¿Desea continuar?</p>
                </>
            </Modal.Body>
            <Modal.Footer>
                <ModalButton className='cancel' onClick={handleClose}>
                    Cancelar
                </ModalButton>
                <ModalButton className='action' onClick={handleAction}>
                    Continuar
                </ModalButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AddDetailReceiptConfirmationModal;
